import React from "react";
import general from "../styles/General.module.scss";
import { useGlobalContext } from "../contextProvider/ContextProvider";

const Start = () => {
  const { setStart, configuratorSubheadline, configuratorDescription } =
    useGlobalContext();

  return (
    <div className={general.startWrapper}>
      {/* <h2 className={`${general.heading} ${general.centered}`}>
        {configuratorTitle}
      </h2> */}
      <p className={`${general.subHeading} ${general.centered}`}>
        {configuratorSubheadline}
      </p>
      <p className={`${general.centered}`} style={{ marginBottom: "50px" }}>
        {configuratorDescription}
      </p>
      <button
        className={`${general.greenButton} ${general.marginCentered}`}
        onClick={() => setStart(true)}
      >
        Starten
      </button>
    </div>
  );
};

export default Start;
